import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";
import { IOrganisationIndexGroup } from "../../organisations/model/OrganisationIndexGroup";
import { IIndexType } from "./IndexType";

export interface TIndexTypeGroup {
  id: number;
  code: string;
  name: string;
  valid: boolean;
  description: string;
  indexTypeCategoryId: number;
  items: IIndexType[];
  childGroups: IIndexTypeGroup[];
  organisationIndexGroupList: IOrganisationIndexGroup[];
  childIds: number[];
  indexTypeIds: number[];
}

export interface IIndexTypeGroup extends TIndexTypeGroup {
  groups: IIndexTypeGroup[];
}

const IndexTypeGroup = Model((model: TIndexTypeGroup): IIndexTypeGroup => {
  const _value: TIndexTypeGroup = Object.assign({}, model);
  let _indexTypeGroup: IIndexTypeGroup[] = [];
  let _childIds: number[] = [];
  let _indexTypeIds: number[] = [];
  let organisationIndexGroupList: IOrganisationIndexGroup[] = [];
  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get code() {
      return _value.code;
    },
    set code(value) {
      _value.code = value;
    },

    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get description() {
      return _value.description;
    },
    set description(value) {
      _value.description = value;
    },
    get indexTypeCategoryId() {
      return _value.indexTypeCategoryId;
    },
    set indexTypeCategoryId(value) {
      _value.indexTypeCategoryId = value;
    },
    get items() {
      return _value.items;
    },
    set items(value) {
      _value.items = value;
    },
    get childGroups() {
      return _value.childGroups;
    },
    set childGroups(value) {
      _value.childGroups = value;
    },
    get groups() {
      return _indexTypeGroup;
    },
    set groups(value) {
      _indexTypeGroup = value;
    },
    get organisationIndexGroupList() {
      return organisationIndexGroupList;
    },
    set organisationIndexGroupList(value) {
      organisationIndexGroupList = value;
    },
    get childIds() {
      return _childIds;
    },
    set childIds(value) {
      _childIds = value;
    },
    get indexTypeIds() {
      return _indexTypeIds;
    },
    set indexTypeIds(value) {
      _indexTypeIds = value;
    }
  };

  return ValidatableObject<IIndexTypeGroup>(_model);
});

export default IndexTypeGroup;
